import { type FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '../IconButton/IconButton.component.tsx';
import { Eye, EyeSlash, LockClosed } from '../Icons';
import { Input, type InputProps } from './Input.component.tsx';

export const PasswordInput: FunctionComponent<InputProps> = (props) => {
  const { t } = useTranslation();
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

  const rightElement = (
    <IconButton
      onClick={() => {
        setIsPasswordVisible(!isPasswordVisible);
      }}
      Icon={isPasswordVisible ? EyeSlash : Eye}
      size={24}
    />
  );

  return (
    <Input
      LeftIcon={LockClosed}
      placeholder={t('components.PasswordInput.placeholder')}
      type={isPasswordVisible ? 'text' : 'password'}
      rightElement={rightElement}
      {...props}
    />
  );
};
